export const TABLE_IVIDEON_LOGS_OPTION = [
  "id",
  "UserFullName",
  "UserRole",
  "createdAt",
  "EventDescription",
];
